<template>
  <div class="warp">
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  methods: {
    getStatisticsData: function(){
      return {
        'ua': navigator.userAgent,
        'system': navigator.platform,
        'url': window.location.href,
        'referrer': window.document.referrer,
        'dpi': this.getDpi(),
        'type': 2 // 1:pc,2:移动端
      }
    },
    getTimestamp: function(){
      return new Date().getTime();
    },
    getDpi: function(){
      return (window.screen.width || 0) + "x" + (window.screen.height || 0);
    },
    postRequest: function(){
      this.$axios.post(window.SITE_CONFIG.baseUrl + '/api/statistics/access-log/record?t=' + this.getTimestamp(), this.getStatisticsData())
    }
  },

  created() {
    this.postRequest()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/statistics.vue